<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.Overall_statistics") }}</h5>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!-- <ComingSoon /> -->

      <!--  =========== Start:: Data Table =========== -->
      <div class="statics mt-4">
        <div class="row">
          <div
            class="col-lg-6 col-md-6 col-12"
            v-for="(value, key) in statics"
            :key="'i' + key"
          >
            <div class="box">
              <div class="icon">
                <i v-if="key === 'providers'" class="fas fa-building"></i>

                <i v-else-if="key === 'clients'" class="fas fa-users"></i>

                <i v-else-if="key === 'ads'" class="fas fa-bullhorn"></i>

                <i
                  v-else-if="key === 'rent_requests'"
                  class="fas fa-file-contract"
                ></i>

                <i v-else-if="key === 'subscriptions'" class="fas fa-crown"></i>

                <i
                  v-else-if="key === 'total_subscriptions_amount'"
                  class="fas fa-dollar-sign"
                ></i>
              </div>

              <div class="info_box">
                <span v-if="key === 'providers'">{{
                  $t("PLACEHOLDERS.providers")
                }}</span>

                <span v-else-if="key === 'clients'">{{
                  $t("PLACEHOLDERS.clients")
                }}</span>

                <span v-else-if="key === 'ads'">{{
                  $t("PLACEHOLDERS.ads")
                }}</span>

                <span v-else-if="key === 'rent_requests'">{{
                  $t("PLACEHOLDERS.rent_requests")
                }}</span>

                <span v-else-if="key === 'subscriptions'">{{
                  $t("PLACEHOLDERS.subscriptions")
                }}</span>

                <span v-else-if="key === 'total_subscriptions_amount'">{{
                  $t("PLACEHOLDERS.total_subscriptions_amount")
                }}</span>

                <p class="number_box">{{ value }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->
  </div>
</template>

<script>
import ComingSoon from "@/components/ui/ComingSoon.vue";

export default {
  name: "HomePage",

  components: {
    ComingSoon,
  },

  data() {
    return {
      statics: [],
    };
  },

  methods: {
    async getStatics() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "statistics",
        });

        this.statics = {
          providers: res.data.data.providers,
          clients: res.data.data.clients,
          ads: res.data.data.ads,
          rent_requests: res.data.data.rent_requests,
          subscriptions: res.data.data.subscriptions,
          total_subscriptions_amount: res.data.data.total_subscriptions_amount,
        };
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
  },

  mounted() {
    this.getStatics();
  },
};
</script>

<style lang="scss" scoped>
.show_all_content_wrapper {
  .statics {
    .box {
      background: #404b3e;
      padding: 25px;
      margin-bottom: 10px;
      border-radius: 5px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;

      transition: all 0.5s;

      &:hover {
        background: #fff;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

        .icon {
          i {
            color: #404b3e;
          }
        }
        .info_box {
          span,
          p.number_box {
            color: #000;
          }
        }
      }

      .icon {
        height: 60px;
        min-width: 60px;
        width: 60px;
        border-radius: 60px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 25px;
          color: #000;
        }
      }

      .info_box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;

        span {
          font-size: 19px;
          color: #fff;
        }

        p.number_box {
          font-size: 30px;
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
}
.show_all_content_wrapper .statics .box .info_box {
  align-items: flex-start !important;
  width: 100% !important;
  padding-inline-start: 5% !important;
}
</style>
